import api from '@api'
import {
  buildFlatQualificationStructure,
  buildRelationalQualificationStructure,
} from '@data/qualification'

const getQualifications = (filters) => {
  const qualDetails = []

  if (filters.createdById) {
    qualDetails.push(
      buildRelationalQualificationStructure(
        'createdById',
        'in',
        [filters.createdById],
        'long',
        'db'
      )
    )
  }

  if (filters.fromDate && filters.toDate) {
    qualDetails.push(
      buildRelationalQualificationStructure(
        'triggeredTime',
        'between',
        [filters.fromDate, filters.toDate],
        'long',
        'db'
      )
    )
  }

  return qualDetails
}

export function getDownloadHistoryAPi(filters, searchCriteria, limit, offset) {
  const qualDetails = [
    ...((searchCriteria || {}).quals || []),
    ...getQualifications(filters),
  ]
  return api
    .post(
      `/analytics/downloadhistory/search/byqual`,
      {
        qualDetails: qualDetails.length
          ? buildFlatQualificationStructure(qualDetails)
          : undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 20 : limit,
          sort_by: 'createdTime',
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: data.objectList || [],
        total: data.totalCount,
      }
    })
}

export function reDownloadApi(id) {
  return api
    .get(`/analytics/downloadhistory/redownload/${id}`, {
      responseType: 'blob',
      notify: false,
      isResponseHeader: true,
      timeout: 0,
    })
    .then(({ data, fileName }) => {
      return import('file-saver').then((FS) => {
        return FS.saveAs(data, fileName)
      })
    })
}

export function cancelDownloadApi(id) {
  return api.post(`/analytics/downloadhistory/cancel/${id}`, {
    notify: true,
  })
}
